import React from "react";

const ContactUs = () => {
  return (
    <div>
      <div>
        <h1 className="text-center text-2xl font-semibold py-2">
          Blood DonationBD - রক্ত খুঁজুন App
        </h1>
        <h1 className="text-center font-bold py-2">Maintain By </h1>
        <h1 className="text-center text-xl font-semibold">
          শান্তি সংঘ ব্লাড কল্যাণ ফাউন্ডেশন
        </h1>
        <h1 className="text-center text-lg font-semibold">
          Shanti Sangh Blood Welfare Foundation
        </h1>
        <h1 className="text-center">Dhaka, Bangladesh</h1>
      </div>

      <div className="pt-[20px] text-center ">
        <h1 className=" text-lg font-semibold">Contact Info</h1>
        <h1>01742934200 - K.M. Abukowsar</h1>
      </div>
      <div className="pt-[20px] text-center ">
        <h1 className=" text-lg font-semibold">For Any App Issue</h1>
        <h1>01891962916- Tayeful Islam</h1>
      </div>
    </div>
  );
};

export default ContactUs;
